export const CONTAINER_CLASS = 'react-onboarding-pro-container';
export const DEFAULT_STEP_CONFIG = {
  title: '',
  description: '',
  type: '',
  component: null,
  props: {},
  fields: [],
  onSubmit: () => { }
}
export const DEFAULT_FIELD_CONFIG = {
  label: '',
  name: '',
  type: '',
  placeholder: '',
  validation: ''
}
